/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetUploadIcon64Regular = forwardRef('NetUploadIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M33.5 8.784a4.488 4.488 0 0 1 1.49.88l14.014 12.457a1.5 1.5 0 1 0 1.992-2.242L36.983 7.422a7.5 7.5 0 0 0-9.966 0L13.004 19.88a1.5 1.5 0 1 0 1.992 2.242L29.01 9.664a4.488 4.488 0 0 1 1.49-.88V46a1.5 1.5 0 0 0 3 0V8.784Z" }),
        React.createElement("path", { d: "M7 56.5A1.5 1.5 0 0 1 8.5 55h47a1.5 1.5 0 0 1 0 3h-47A1.5 1.5 0 0 1 7 56.5Z" })));
});
